module.exports = __webpack_public_path__ + "img/report_graphic.f3d88a69.svg";